import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.AccountNavigation
//import "../AccountNavigation.js";

/**
* class HSN.AccountNavigation.Cabinet
*
* Encapsulates and manages the interactions between multiple
* [[HSN.AccountNavigation.Cabinet]] instances.
**/
HSN.AccountNavigation.Cabinet = function (config) {
    /**
     * new HSN.AccountNavigation.Cabinet(config)
     * - config (Object): A configuration object for the [[HSN.AccountNavigation.Cabinet]]
     *   consisting of the following keys:
     *   - drawers ([HSN.AccountNavigation.Cabinet.Drawer]): The collection of [[HSN.AccountNavigation.Cabinet.Drawer]] instances for the [[HSN.AccountNavigation.Cabinet]] to manage and coordinate.
     *   - id (String): The value of the cabinet's `id` attribute to be used as a styling hook.
     **/
    var __scope = this;

    config = (config = config || {});

    this.Drawers = config.drawers;
    this.Root = $('<div id="' + config.id + '" class="clearfix"></div>');
    this.Wrap = $('<div class="wrap"></div>');
    this.Content = $('<div class="content"></div>');
    this.Closer = $('<span class="ir close">&times;</span><span class="close-alt">CLOSE</span>');

    this.Wrap.append(this.Closer);
    this.Wrap.append(this.Content);
    this.Root.append(this.Wrap);
    //this.Root.append('<hr>');

    this.Closer.on('click', function (e) {
      __scope.Close();
    });

    $(window).on('keydown', function (event) {
      var keyCode = event.keyCode || event.which;
      if (keyCode != 27) {
        return;
      }

      $.each(__scope.Drawers, function (i, drawer) {
        if (__scope.State == HSN.AccountNavigation.Cabinet.State.Open && drawer == __scope.GetActiveDrawer()) {
          __scope.Close();
        }
      });
    });

    $.each(this.Drawers, function (i, drawer) {
      drawer.Trigger.on('click', function (e) {

        if (drawer.NoAjax) {
          var cookie = "signin=";
          var crumb = "ref=" + window.location.href;
          var domain = "; domain=.hsn.com";
          var path = "; path=/";
          document.cookie = cookie + crumb + domain + path;
          return;
        }

        e.preventDefault();

        if (__scope.State == HSN.AccountNavigation.Cabinet.State.Open && drawer == __scope.GetActiveDrawer()) {
          __scope.Close();
          return false;
        }

        __scope.Open(drawer);
        return false;
      });
    });
  };

  /**
  * HSN.AccountNavigation.Cabinet.EVENT = Object
  *
  * An enumeration of events an [[HSN.AccountNavigation.Cabinet]] can raise:
  * - BEFORE_OPEN: Right before the flyout is opened.
  * - BEFORE_CLOSE: Right before the flyout is opened.
  **/
  HSN.AccountNavigation.Cabinet.EVENT = {
    BEFORE_CLOSE: 'cabinet:before_close',
    AFTER_CLOSE: 'cabinet:after_close',
    BEFORE_OPEN: 'cabinet:before_open',
    AFTER_OPEN: 'cabinet:after_open',
    OPEN_SAVEFORLATER: 'cabinet:open_saveforlater',
    OPEN_PREVIEW: 'cabinet:open_preview'
  };

  /**
   * HSN.AccountNavigation.Cabinet.State = Object
   *
   * An enumeration of potential states for an [[HSN.AccountNavigation.Cabinet]] with the following members:
   * - Closed
   * - Open
   **/
  HSN.AccountNavigation.Cabinet.State = {
    Closed: 0,
    Open: 1
  };

  HSN.AccountNavigation.Cabinet.prototype = {
    _activeDrawer: null,

    /**
     * HSN.AccountNavigation.Cabinet#State -> HSN.AccountNavigation.Cabinet.State
     *
     * Holds the current state of the [[HSN.AccountNavigation.Cabinet]]
     **/
    State: HSN.AccountNavigation.Cabinet.State.Closed,

    /**
     * HSN.AccountNavigation.Cabinet#Close([callback]) -> void
     * - callback (Function): The optional function to call once the drawer has opened
     *
     * Closes the cabinet, if open, and then fires the given
     * `callback`, if provided.
     **/
    Close: function (callback) {
      var __scope = this;

      HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_CLOSE, this);
      __scope.Root.filter(":not(:animated)").slideUp(250, function () {
        __scope.State = HSN.AccountNavigation.Cabinet.State.Closed;
        $.each(__scope.Drawers, function (i, drawer) {
          drawer.Trigger.removeClass('open');
          if (drawer.CloseCallback) {
            drawer.CloseCallback();
          }
        });
        __scope._activeDrawer = null;

        if (callback) {
          callback();
        }
        HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.AFTER_CLOSE, this);
      });
    },

    /**
     * HSN.AccountNavigation.Cabinet#FindDrawerByIdentifier(identifier) -> HSN.AccountNavigation.Cabinet.Drawer | null
     * - identifier (String): The identifier of the [[HSN.AccountNavigation.Cabinet.Drawer]] being looked for.
     *
     * Returns the [[HSN.AccountNavigation.Cabinet.Drawer]] in the [[HSN.AccountNavigation.Cabinet]]'s collection with the identifier provided.
     **/
    FindDrawerByIdentifier: function (identifier) {
      var drawersLength = this.Drawers.length;
      for (var i = 0; i < drawersLength; i++) {
        if (this.Drawers[i].Identifier == identifier) {
          return this.Drawers[i];
        }
      }
      return null;
    },

    /**
     * HSN.AccountNavigation.Cabinet#GetActiveDrawer() -> HSN.AccountNavigation.Cabinet.Drawer | null
     *
     * Returns the currently active [[HSN.AccountNavigation.Cabinet.Drawer]],
     * of null if no drawer is active.
     **/
    GetActiveDrawer: function () {
      return this._activeDrawer;
    },

    /**
     * HSN.AccountNavigation.Cabinet#Open(drawer) -> void
     * - callback (HSN.AccountNavigation.Cabinet.Drawer | String): The drawer to load into the cabinet as it opens, or the identifier of a drawer.
     *
     * Opens the cabinet, if it is currently closed, and loads the contents of the provided
     * [[HSN.AccountNavigation.Cabinet.Drawer]] into it.
     **/
    Open: function (drawer) {
      if (typeof (drawer) == "string") {
        drawer = this.FindDrawerByIdentifier(drawer);
      }

      if (null == drawer) {
        return;
      }
      var __scope = this;
      HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
      var supportsFading = !$("html").hasClass("lt-ie9");
      __scope.Root.addClass('loading');
      __scope.Root.filter(":not(:animated)").slideDown(250, function () {
        __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

        $.each(__scope.Drawers, function (i, drawer) {
          drawer.Trigger.removeClass('open');
        });
        drawer.Trigger.addClass('open');
        __scope._activeDrawer = drawer;

        $.ajax
        (
            drawer.Url,
            {
              cache: false,
              context: drawer,
              dataType: 'html',
              success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');
                __scope.Content.showHtml(data, 250, function () {
                  if (drawer.Callback) drawer.Callback(drawer);
                  if (supportsFading) {
                    __scope.Content.animate({ opacity: 1 });
                  }
                  else {
                    __scope.Content.css("opacity", "1");
                  }
                  HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.AFTER_OPEN, this);
                  //TODO: wrap this in a coremetrics check?
                  cX('onload');
                });
              },
              error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
              }
            }
        );
      });

      HSN.Instance().Events.On(HSN.Application.EVENT.ARCADE_HEADER_MOUSELEAVE, function () {
        if (__scope.State === HSN.AccountNavigation.Cabinet.State.Open) {
          __scope.Close();
        }

        return false;
      });
    },

    OpenSaveForLater: function (drawer) {
      if (typeof (drawer) == "string") {
        drawer = this.FindDrawerByIdentifier(drawer);
      }

      if (null == drawer) {
        return;
      }

      var __scope = this;
      var supportsFading = !$("html").hasClass("lt-ie9");

      HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
      this.Content.animate({ opacity: supportsFading ? 0 : 1 }, 250, function () {
        __scope.Root.addClass('loading');
        __scope.Root.slideDown(250, function () {
          __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

          $.each(__scope.Drawers, function (i, drawer) {
            drawer.Trigger.removeClass('open');
          });
          drawer.Trigger.addClass('open');
          __scope._activeDrawer = drawer;

          $.ajax
          (
            drawer.Url,
            {
              cache: false,
              context: drawer,
              dataType: 'html',
              success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');
                __scope.Content.showHtml(data, 250, function () {
                  if (drawer.Callback) drawer.Callback(drawer);
                  if (supportsFading) {
                    __scope.Content.animate({ opacity: 1 });
                  }
                  else {
                    __scope.Content.css("opacity", "1");
                  }
                });
                HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.OPEN_SAVEFORLATER, this);
              },
              error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
              }
            }
          );
        });
      });
    },

    OpenPreview: function (drawer) {
      if (typeof (drawer) == "string") {
        drawer = this.FindDrawerByIdentifier(drawer);
      }

      if (null == drawer) {
        return;
      }

      var __scope = this;
      var supportsFading = !$("html").hasClass("lt-ie9");

      HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.BEFORE_OPEN, this);
      this.Content.animate({ opacity: supportsFading ? 0 : 1 }, 250, function () {
        __scope.Root.addClass('loading');
        __scope.Root.slideDown(250, function () {
          __scope.State = HSN.AccountNavigation.Cabinet.State.Open;

          $.each(__scope.Drawers, function (i, drawer) {
            drawer.Trigger.removeClass('open');
          });
          drawer.Trigger.addClass('open');
          __scope._activeDrawer = drawer;

          $.ajax
          (
            drawer.Url,
            {
              cache: false,
              context: drawer,
              dataType: 'html',
              success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');
                __scope.Content.showHtml(data, 250, function () {
                  if (drawer.Callback) drawer.Callback(drawer);
                  if (supportsFading) {
                    __scope.Content.animate({ opacity: 1 });
                  }
                  else {
                    __scope.Content.css("opacity", "1");
                  }
                });
                HSN.Instance().Events.Trigger(HSN.AccountNavigation.Cabinet.EVENT.OPEN_PREVIEW, this);
              },
              error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
              }
            }
          );
        });
      });
    },

    Reload: function () {
      if (this.State != HSN.AccountNavigation.Cabinet.State.Open || !this._activeDrawer) {
        return false;
      }
      return this.Open(this._activeDrawer);
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/AccountNavigation/Cabinet.js